import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import DescriptionParamTable from '../../../../../Components/DescriptionParamTable';

const Wrapper = styled.div`
  padding: ${rem(4)};
`;

const DescriptionWrapper = styled.div`
  font-size: ${rem(14)};
  margin-bottom: ${rem(8)};
  margin-top: ${rem(8)};
  color: #434245;
  text-align: justify;
`;

class Description extends React.Component {
  render() {
    const { description, params } = this.props;

    return (
      <Wrapper>
        <DescriptionWrapper>{description}</DescriptionWrapper>
        <DescriptionParamTable data={params || []} />
      </Wrapper>
    );
  }
}

Description.propTypes = {
  firm: PropTypes.firm,
  description: PropTypes.string,
  params: PropTypes.arrayOf({
    name: PropTypes.string,
    value: PropTypes.string,
  }),
};

Description.defaultProps = {
  firm: 'SK',
  description: '',
  params: [],
};

export default Description;



// WEBPACK FOOTER //
// ./src/Containers/Buy/Catalog/Detail/Description/index.jsx